import React, { useState } from 'react';
import './HeroSection.css';
import { SHOW_STAGE_RESULTS, isRegistrationOpen } from '../config/featureFlags';

interface HeroSectionProps {
  onOpenRegistration: () => void;
  isLoggedIn: boolean;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onOpenRegistration, isLoggedIn }) => {
  const registrationOpen = isRegistrationOpen();
  const [isResultsOpen, setIsResultsOpen] = useState(false);

  const scrollToConditions = () => {
    const element = document.getElementById('documents');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <section className="hero-section">
        <div className="hero-image-container">
          {/* Здесь будет фоновое изображение на 1/3 высоты */}
        </div>
        <div className="hero-content">
          <div className="hero-title">
            <h1>ВСЕРОССИЙСКИЙ ХАКАТОН<br />ПО НАНОТЕХНОЛОГИЯМ</h1>
          </div>
          <div className="hero-buttons">
            {!isLoggedIn && registrationOpen && (
              <button
                className="hero-button register-button"
                onClick={onOpenRegistration}
              >
                Регистрация
              </button>
            )}
            {SHOW_STAGE_RESULTS && (
            <div className="hero-dropdown">
              <button 
                className="hero-button register-button"
                onClick={() => setIsResultsOpen((prev) => !prev)}
              >
                Результаты отборочного этапа
              </button>
              {isResultsOpen && (
                <div className="dropdown-menu">
                  <a 
                    className="dropdown-item"
                    href="/static/Protokol_Nanokhakaton_otborochny_etap.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Протокол отборочного этапа
                  </a>
                  <a 
                    className="dropdown-item"
                    href="https://disk.yandex.ru/d/fompHSA98-b9nw"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Сертификаты участников
                  </a>
                  <a 
                    className="dropdown-item"
                    href="https://disk.yandex.ru/d/1nptepTrHhKs8Q"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Письма-приглашения финалистов
                  </a>
                </div>
              )}
            </div>
            )}
            <button 
              className="hero-button rules-button"
              onClick={scrollToConditions}
            >
              Положение о конкурсе
            </button>
          </div>
        </div>
      </section>

    </>
  );
};

export default HeroSection; 